import { useCallback } from 'react';

import { type Task } from '@air/classes-task-scheduler';

import { type UploadTaskParams } from '~/components/Upload/hooks/types';
import { useUploadSmallPublicFile } from '~/components/Upload/publicUpload/useUploadSmallPublicFile';

export const useGetSmallPublicUploadTask = () => {
  const { uploadSmallPublicFile } = useUploadSmallPublicFile();

  const getSmallUploadTask = useCallback(
    (params: UploadTaskParams): Task => {
      return {
        id: params.uploadId,
        run: () => uploadSmallPublicFile(params),
      };
    },
    [uploadSmallPublicFile],
  );

  return {
    getSmallUploadTask,
  };
};
